module.exports = __webpack_public_path__ + "static/media/oil.888c311e.png";